import { z } from 'zod';

import { SectionDtoScheme } from '~modules/section/model/dto.ts';

export const DeviceDtoScheme = z.object({
	id: z.number().describe('Уникальный идентификатор').nullable().optional(),
	number: z.string().describe('Номер'),
	code: z.string().describe('Уникальный идентификатор'),
	section_id: z.number().describe('Идентификатор участка'),
	section: SectionDtoScheme.describe('Участок').nullable().optional(),
});

export type DeviceDto = z.infer<typeof DeviceDtoScheme>;
